import { Form, Input, Button, Checkbox, Tabs } from 'antd';
import {useState} from "react";
import {useApi} from "../provider/ApiProvider";
import axios from "axios";
import FullLoader from "../components/FullLoader";

const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};

const { TabPane } = Tabs;

export default function Login(){
    const [loading, setLoading] = useState(false);
    const {api, login} = useApi();

    const onFinish = async (values) => {
        setLoading(true);
        await api.post('/authRouter/login',values).then(resp => {
            console.log(resp, 'resp');
            let user = resp.user;
            user.token = resp.token;
            login(user);
            window.location.assign('/');
            setLoading(false);
        }).finally(() => {
            setLoading(false);
        })
    };

    const onFinishFailed = (errorInfo) => {

    };

    return (
        <>
            <FullLoader show={loading}/>
            <div className="login-area">
                <div className="login">
                    <div className="title">
                        <div className="content">
                            <div className="title-text">
                                TEKNODX
                            </div>

                            <div className="subtitle-text">
                                Yönetim Paneli
                            </div>
                        </div>

                    </div>

                    <Form
                        {...layout}
                        name="basic"
                        initialValues={{
                            remember: true,
                        }}
                        onFinish={onFinish}
                        onFinishFailed={() => onFinishFailed("İstenen bilgileri giriniz")}
                    >
                        <Form.Item
                            label="Tc No"
                            name="identityNumber"
                            rules={[
                                {
                                    required: true,
                                    message: 'Kullanıcı adınızı giriniz',
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="Şifre"
                            name="password"
                            rules={[
                                {
                                    required: true,
                                    message: 'Şifrenizi giriniz',
                                },
                            ]}
                        >
                            <Input.Password />
                        </Form.Item>

                        {/*<Form.Item  name="remember" valuePropName="checked">*/}
                        {/*    <Checkbox>Remember me</Checkbox>*/}
                        {/*</Form.Item>*/}


                        <Button className="submit-btn" loading={loading} block type="primary" htmlType="submit">
                            Giriş Yap
                        </Button>

                    </Form>
                </div>
            </div>
        </>

    )
}
